import types from './types';

const InitialState = {
    active: [],
    data: {
        welcome_package: {
            game: null
        },
        affiliate_signup: {
            stage: 'choose',
            choose: {},
            signup: {
                button: false
            },
            phone_confirmation: {
                resend: false,
                button: false
            },
            notifications: {
                button: false
            },
            phone_change: {
                button: false
            }
        }
    }
} 

export default (state = InitialState, {type, payload}) => {
    switch(type) {
        case types.stage.toggleButton: 
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload]: {
                        ...state.data[payload],
                        [state.data[payload].stage]: {
                            ...state.data[payload].stage,
                            button: !state.data[payload].button
                        }
                    }
                }
            }
        case types.stage.update: 
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.modal]: {
                        ...state.data[payload.modal],
                        [state.data[payload.modal].stage]: {
                            ...state.data[payload.modal].stage,
                            ...payload.data
                        }
                    }
                }
            }
        case types.stage.set:
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.modal]: {
                        ...state.data[payload.modal],
                        stage: payload.stage
                    }
                }
            }
        case types.setData:
            return {
                ...state,
                data: {
                    ...state.data,
                    [payload.modal]: {
                        ...state.data[payload.modal],
                        ...payload.data
                    }
                }
            }
        case types.open:
            return {
                ...state,
                active: state.active.includes(payload) ? state.active : [payload, ...state.active]
            }
        case types.toggle:
            return {
                ...state,
                active: state.active.filter(m => m.key === payload.key).length > 0 ? state.active.filter(m => m.key != payload.key) : [payload, ...state.active]
            }
        default:
            return state;
    } 
}